<template>
  <div id="hrms14x">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchParams"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHrms14xIndex"
            :columnEvent="columnEvent"
            :csvExportDisp="true"
            searchBoxAlias="hrms14x"
            :callSearchEvent="callSearchEvent" />

    <input data-toggle="modal" data-target="#hrms14x-popup-status" ref="popupStatus" type="hidden"/>
    <input data-toggle="modal" data-target="#hrms14x-popup-route-no" ref="popupRouteNo" type="hidden"/>

    <popup-status   :popupStatusEditDisp="popupStatusEditDisp"
                    :setPopupStatusEditDisp="setPopupStatusEditDisp"
                    :labels="labels[dash.nowLang]"
                    :labelsButton="dash.button[dash.nowLang]"
                    :columns="columns[dash.nowLang].popupStatusColumns"
                    :columnsStatusEdit="columns[dash.nowLang].popupStatusEditColumns"
                    :nowLang="dash.nowLang"
                    :data="popupStatus"
                    :dataStatusEdit="popupStatusEdit"
                    :indexSelected="indexSelected"
                    :searchParams="searchParams"
                    :setPopupSelected="setPopupSelected"
                    :popupSelected="popupSelected"
                    :receivedHrms14xStatusEditPopup="receivedHrms14xStatusEditPopup"
                    :postPopupStatusEditSave="postPopupStatusEditSave"
                    :codcomp="searchParams.codcomp" />

    <popup-route-no :labels="labels[dash.nowLang]"
                    :columns="columns[dash.nowLang].popupRouteNoColumns"
                    :nowLang="dash.nowLang"
                    :data="popupRouteNo"
                    :indexSelected="indexSelected"
                    :searchParams="searchParams" />


  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms14x/mutation-types'
import * as lovTypes from 'store/modules/hrmsLov/mutation-types'
import moment from 'moment'
import popupStatus from 'components/hrms14x/popupStatus'
import popupRouteNo from 'components/hrms14x/popupRouteNo'

export default {
  name: 'hrms14x',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      searchParams: {
        codapp: 'HRES62E',
        dtestrt: '01/01/' + moment().format('YYYY'),
        dteend: moment().format('DD/MM/YYYY')
      }
    }
  },
  created () {
    this.receivedHrms14xColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      lovCurrentDesc: lovTypes.GET_LOV_CURRENT_DESC,
      searchParamsIndex: types.GET_HRMS14X_SEARCH_PARAMS_INDEX,
      indexDisp: types.GET_HRMS14X_INDEX_DISP,
      popupStatusEditDisp: types.GET_HRMS14X_POPUP_STATUS_EDIT_DISP,
      columns: types.GET_HRMS14X_COLUMNS,
      labels: types.GET_HRMS14X_LABELS,
      index: types.GET_HRMS14X_INDEX,
      indexSelected: types.GET_HRMS14X_INDEX_SELECTED,
      popupSelected: types.GET_HRMS14X_POPUP_SELECTED,
      popupStatus: types.GET_HRMS14X_STATUS_POPUP,
      popupStatusEdit: types.GET_HRMS14X_STATUS_EDIT_POPUP,
      popupRouteNo: types.GET_HRMS14X_ROUTE_NO_POPUP
    })
  },
  methods: {
    merge (indexSelected, searchParamsIndex) {
      let searchBoxParams = {
        codapp: searchParamsIndex.codapp,
        desc_codapp: this.lovCurrentDesc('codapp', searchParamsIndex.codapp)
      }
      return Object.assign(indexSelected, searchBoxParams)
    },
    columnEvent (eventName, param) {
      this.setIndexSelected(param)
      this.searchParams = this.merge(this.indexSelected, this.searchParamsIndex)
      switch (eventName) {
        case 'status':
          this.receivedHrms14xStatusPopup(this.searchParams)
          this.$refs.popupStatus.click()
          break
        case 'routeno':
          this.receivedHrms14xRouteNoPopup(this.searchParams)
          this.$refs.popupRouteNo.click()
          break
      }
    },
    callSearchEvent () {
      if (this.searchParams.codempid3 !== '') {
        this.searchParams.codcomp = ''
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS14X_INDEX_SELECTED,
      setPopupSelected: types.SET_HRMS14X_POPUP_SELECTED,
      setPopupStatusEditDisp: types.SET_HRMS14X_POPUP_STATUS_EDIT_DISP
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS14X_PAGE,
      receivedHrms14xColumnsLabels: types.RECEIVED_HRMS14X_COLUMNS_LABELS,
      receivedHrms14xIndex: types.RECEIVED_HRMS14X_INDEX,
      receivedHrms14xStatusPopup: types.RECEIVED_HRMS14X_STATUS_POPUP,
      receivedHrms14xStatusEditPopup: types.RECEIVED_HRMS14X_STATUS_EDIT_POPUP,
      receivedHrms14xRouteNoPopup: types.RECEIVED_HRMS14X_ROUTE_NO_POPUP,
      postPopupStatusEditSave: types.POST_HRMS14X_STATUS_EDIT_SAVE
    })
  },
  components: {
    popupStatus,
    popupRouteNo
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?2de3d40a